import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    curVideoSrc: "",
    guestsList: {
      // 2月28日
      kv28: [
        {
          time: "19:00",
          subjectTitle: "有问必答，鹏友说的科技咖们没在怕的",
          repalySrc: "https://www.ixigua.com/iframe/6923260121724224008?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/张鹏2.jpg",
              name: "张鹏",
              companyName: "极客公园",
              title: "创始人 & 总裁",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/张鹏2.jpg"],
        },
        {
          time: "19:10",
          subjectTitle: "关于抖音的社交本质、本质和未来",
          repalySrc: "https://www.ixigua.com/iframe/6923260432031580680?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923261350881952263?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/张楠.jpg",
              name: "张楠",
              companyName: "北京字节跳动",
              title: "CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/张楠.jpg"],
        },
        {
          time: "19:25",
          subjectTitle: "企业家干点儿啥才算「大气」？",
          repalySrc: "https://www.ixigua.com/iframe/6923262578005115406?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923266543161704967?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/周鸿祎.jpg",
              name: "周鸿祎",
              companyName: "360 集团",
              title: "董事长 & CEO",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/朱一旦的枯燥生活.jpg",
              name: "朱一旦的枯燥生活",
              companyName: "抖音创作者",
              title: "黑色幽默的人间观察家",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/周鸿祎.jpg", "https://summit-img.geekpark.net/if2021/pc/朱一旦的枯燥生活.jpg"],
        },
        {
          time: "19:50",
          subjectTitle: "「得到」与「失去」—— 听听我对数字世界的新反思",
          repalySrc: "https://www.ixigua.com/iframe/6923267380508361229?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923268908304564750?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/罗振宇.jpg",
              name: "罗振宇",
              companyName: "得到App",
              title: "创始人 思维造物董事长",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/大能.jpg",
              name: "大能",
              companyName: "抖音创作者",
              title: "十年玩表正经人",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/罗振宇.jpg", "https://summit-img.geekpark.net/if2021/pc/大能.jpg"],
        },
        {
          time: "20:10",
          subjectTitle: "2020，抖音的改变与思考",
          repalySrc: "https://www.ixigua.com/iframe/6923269224374731271?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/支颖.jpg",
              name: "支颖",
              companyName: "抖音",
              title: "市场副总裁",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/支颖.jpg"],
        },
        {
          time: "20:30",
          subjectTitle: "创业到底是物理问题，还是生物问题？",
          repalySrc: "https://www.ixigua.com/iframe/6923276266158326285?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923276886550249997?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/王小川.jpg",
              name: "王小川",
              companyName: "搜狗公司",
              title: "CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/王小川.jpg"],
        },
        {
          time: "20:50",
          subjectTitle: "互联网能让教育更好吗？",
          repalySrc: "https://www.ixigua.com/iframe/6923277095837630984?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923281252657136136?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/罗斌.jpg",
              name: "罗斌",
              companyName: "跟谁学 高途课堂",
              title: "联合创始人 & 副总裁",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/罗斌.jpg"],
        },
        {
          time: "21:10",
          subjectTitle: "投资者如何看待企业与企业家？",
          repalySrc: "https://www.ixigua.com/iframe/6923286598700237326?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923286982584074765?autoplay=0&startTime=0",
          repalySrc3: "https://www.ixigua.com/iframe/6923287731137151495?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/方三文.jpg",
              name: "方三文",
              companyName: "雪球",
              title: "创始人 & 董事长",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/周媛.jpg",
              name: "周媛",
              companyName: "抖音创作者",
              title: "让财经更好看的财经主播",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/方三文.jpg", "https://summit-img.geekpark.net/if2021/pc/周媛.jpg"],
        },
        {
          time: "21:30",
          subjectTitle: "最美逆袭，聊聊蔚来的未来在何方？",
          repalySrc: "https://www.ixigua.com/iframe/6923288612196844045?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923290673084891662?autoplay=0&startTime=0",
          repalySrc3: "https://www.ixigua.com/iframe/6923291386598916622?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/李斌.jpg",
              name: "李斌",
              companyName: "蔚来",
              title: "创始人 & 董事长 & CEO",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/虎哥说车.jpg",
              name: "虎哥说车",
              companyName: "抖音创作者",
              title: "不止于车的说车人",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/李斌.jpg", "https://summit-img.geekpark.net/if2021/pc/虎哥说车.jpg"],
        },
      ],
      // 2月29日
      kv29: [
        {
          time: "19:00",
          subjectTitle: "2020科技热榜点评人",
          repalySrc: "",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/蛋解创业.jpg",
              name: "蛋解创业",
              companyName: "抖音创作者",
              title: "最爱吃瓜的商业说书人",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/蛋解创业.jpg"],
        },
        {
          time: "19:10",
          subjectTitle: "美团不只有袋鼠耳朵，还有13000 件「格子衫」！",
          repalySrc: "https://www.ixigua.com/iframe/6923600793991905800?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/夏华夏.jpg",
              name: "夏华夏",
              companyName: "美团",
              title: "首席科学家",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/夏华夏.jpg"],
        },
        {
          time: "19:30",
          subjectTitle: "做服务型机器人，我们是认真的",
          repalySrc: "https://www.ixigua.com/iframe/6923602432220103176?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/傅盛.jpg",
              name: "傅盛",
              companyName: "猎豹移动",
              title: "董事长 & CEO 猎户星空董事长",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/傅盛.jpg"],
        },
        {
          time: "19:45",
          subjectTitle: "自动驾驶跟着「老司机」都在学什么？",
          repalySrc: "https://www.ixigua.com/iframe/6923603055720006152?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/孟醒.jpg",
              name: "孟醒",
              companyName: "滴滴自动驾驶公司",
              title: "COO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/孟醒.jpg"],
        },
        {
          time: "20:05",
          subjectTitle: "当我们买智能汽车时，实际上买的是啥？",
          repalySrc: "https://www.ixigua.com/iframe/6923605303174889992?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/余凯.jpg",
              name: "余凯",
              companyName: "地平线",
              title: "创始人 & CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/余凯2.jpg"],
        },
        {
          time: "20:25",
          subjectTitle: "下一代「导航」，如何帮你圆梦「人车合一」？",
          repalySrc: "https://www.ixigua.com/iframe/6923605746458296840?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/韦东.jpg",
              name: "韦东",
              companyName: "高德地图",
              title: "副总裁 & 汽车业务中心总经理",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/韦东.jpg"],
        },
        {
          time: "20:45",
          subjectTitle: "一家汽车企业为什么在探索「超级计算机」和「飞行汽车」？",
          repalySrc: "https://www.ixigua.com/iframe/6923607225290195463?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923608272356246023?autoplay=0&startTime=0",
          repalySrc3: "https://www.ixigua.com/iframe/6923610673628840461?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/何小鹏.jpg",
              name: "何小鹏",
              companyName: "小鹏汽车",
              title: "董事长 & CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/何小鹏.jpg"],
        },
        {
          time: "21:05",
          subjectTitle: "让一线城市羡慕嫉妒恨的最后三公里",
          repalySrc: "https://www.ixigua.com/iframe/6923612349756768782?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/翟光龙.jpg",
              name: "翟光龙",
              companyName: "松果出行",
              title: "创始人 & CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/翟光龙.jpg"],
        },
        {
          time: "21:25",
          subjectTitle: "来认识下，进击的「中国制造2.0」",
          repalySrc: "https://www.ixigua.com/iframe/6923612827093729806?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923613323363615239?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/黄汪.jpg",
              name: "黄汪",
              companyName: "华米科技",
              title: "创始人 & 董事长 & CEO",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/王野.jpg",
              name: "王野",
              companyName: "九号公司",
              title: "联合创始人 & 总裁",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/昌敬.jpg",
              name: "昌敬",
              companyName: "石头科技",
              title: "董事长 & CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/黄汪.jpg", "https://summit-img.geekpark.net/if2021/pc/王野.jpg", "https://summit-img.geekpark.net/if2021/pc/昌敬.jpg"],
        },
        {
          time: "21:45",
          subjectTitle: "内容平台的变化与趋势",
          repalySrc: "https://www.ixigua.com/iframe/6923615543052206599?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/潘乱.jpg",
              name: "潘乱",
              companyName: "头条创作人",
              title: "科技评论作者",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/潘乱.jpg"],
        },
        {
          time: "22:00",
          subjectTitle: "数字时代的人类秩序",
          repalySrc: "https://www.ixigua.com/iframe/6923616140946047495?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923616758918021639?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/施展.jpg",
              name: "施展",
              companyName: "外交学院",
              title: "教授 & 西瓜视频创作人",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/施展2.jpg"],
        },
      ],
      // 2月30日下午
      kv30_1: [
        {
          time: "14:00",
          subjectTitle: "未来中国科技打卡助力官",
          repalySrc: "https://www.ixigua.com/iframe/6923866961868751367?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/苟胜老师.jpg",
              name: "苟胜老师",
              companyName: "抖音创作者",
              title: "航空航天百科全书",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/苟胜老师.jpg"],
        },
        {
          time: "14:05",
          subjectTitle: "「没什么用」的天文有什么用？",
          repalySrc: "",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/贾阳.jpg",
              name: "贾阳",
              companyName: "月球及火星探测器",
              title: "副总设计师",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/李菂.jpg",
              name: "李菂",
              companyName: "国家天文台FAST",
              title: "首席科学家",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/苟利军.jpg",
              name: "苟利军",
              companyName: "国家天文台",
              title: "研究员 & 恒星级黑洞研究团组首席科学家",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/贾阳.jpg", "https://summit-img.geekpark.net/if2021/pc/李菂.jpg", "https://summit-img.geekpark.net/if2021/pc/苟利军.jpg"],
        },
        {
          time: "14:20",
          subjectTitle: "太空挖矿是否会成为人类新起点",
          repalySrc: "https://www.ixigua.com/iframe/6923870314137190920?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923874595736912391?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/喻天弘.jpg",
              name: "喻天弘",
              companyName: "起源太空",
              title: "联合创始人 & COO",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/直男财经.jpg",
              name: "直男财经",
              companyName: "抖音创作者",
              title: "说财经的脱口秀达人",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/喻天弘.jpg", "https://summit-img.geekpark.net/if2021/pc/直男财经.jpg"],
        },
        {
          time: "14:45",
          subjectTitle: "带着机器狗遛弯是什么样的体验",
          repalySrc: "https://www.ixigua.com/iframe/6923887684888822284?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/王兴兴.jpg",
              name: "王兴兴",
              companyName: "宇树科技",
              title: "创始人 & CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/王兴兴.jpg"],
        },
        {
          time: "15:00",
          subjectTitle: "城市空中交通，打「飞的」不是梦！",
          repalySrc: "https://www.ixigua.com/iframe/6923890705341350414?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923893041128440334?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/胡华智.jpg",
              name: "胡华智",
              companyName: "亿航智能 / EHang",
              title: "创始人 & 董事长 & CEO",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/多余和毛毛姐.jpg",
              name: "多余和毛毛姐",
              companyName: "抖音创作者",
              title: "邻家泼辣多变体",
            },
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/飞行员欧文讲故事.jpg",
              name: "飞行员欧文讲故事",
              companyName: "抖音创作者",
              title: "航空界的单口相声演员",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/胡华智.jpg", "https://summit-img.geekpark.net/if2021/pc/多余和毛毛姐.jpg", "https://summit-img.geekpark.net/if2021/pc/飞行员欧文讲故事.jpg"],
        },
        {
          time: "15:25",
          subjectTitle: "父亲眼中的女儿，可惜她不是人",
          repalySrc: "https://www.ixigua.com/iframe/6923901523084870158?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923904466068439565?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/李笛.jpg",
              name: "李笛",
              companyName: "小冰公司",
              title: "CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/李笛.jpg"],
        },
        {
          time: "15:45",
          subjectTitle: "会写「情书」的AI是在砸人类的饭碗么？",
          repalySrc: "https://www.ixigua.com/iframe/6923907367612449287?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923914788649206285?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/李志飞.jpg",
              name: "李志飞",
              companyName: "出门问问",
              title: "创始人 & CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/李志飞.jpg"],
        },
        {
          time: "16:05",
          subjectTitle: "别把智能家居做成极客玩具",
          repalySrc: "https://www.ixigua.com/iframe/6923916698697335303?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923921954160411149?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/唐沐.jpg",
              name: "唐沐",
              companyName: "如影智能",
              title: "创始人 & CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/唐沐.jpg"],
        },
        {
          time: "16:30",
          subjectTitle: "混合现实的世界里，虚拟的也是真实的",
          repalySrc: "https://www.ixigua.com/iframe/6923926062343094792?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/徐驰.jpg",
              name: "徐驰",
              companyName: "Nreal",
              title: "创始人 & CEO",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/徐驰.jpg"],
        },
      ],
      // 2月30日晚上
      kv30_2: [
        {
          time: "19:00",
          subjectTitle: "「真还传」男主的年度新国货带货报告",
          repalySrc: "https://www.ixigua.com/iframe/6923937006435500552?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923941359204172302?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/罗永浩.jpg",
              name: "罗永浩",
              companyName: "交个朋友",
              title: "首席好物推荐官",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/罗永浩.jpg"],
        },
        {
          time: "19:20",
          subjectTitle: "从麻辣烫到小龙虾，我的真 · 科技 · 致富经",
          repalySrc: "https://www.ixigua.com/iframe/6923944576176783880?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923947069644210696?autoplay=0&startTime=0",
          repalySrc3: "https://www.ixigua.com/iframe/6923949431972692487?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/李剑.jpg",
              name: "李剑",
              companyName: "信良记",
              title: "CEO 新辣道创始人",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/李剑.jpg"],
        },
        {
          time: "19:40",
          subjectTitle: "「熬夜头子」的自述：中国人喝咖啡的真相",
          repalySrc: "https://www.ixigua.com/iframe/6923951531767104014?autoplay=0&startTime=0",
          repalySrc2: "https://www.ixigua.com/iframe/6923953760196624904?autoplay=0&startTime=0",
          personInfo: [
            {
              avatarSrc: "https://summit-img.geekpark.net/if2021/m/张洪基2.jpg",
              name: "张洪基",
              companyName: "连咖啡",
              title: "联合创始人",
            },
          ],
          pcInfo: ["https://summit-img.geekpark.net/if2021/pc/张洪基2.jpg"],
        },
      ],
    },
  },
  mutations: {
    handleVSrcToggle(state, curVideoSrc) {
      state.curVideoSrc = curVideoSrc;
    },
  },
  actions: {},
  modules: {},
});
